(function () {
    'use strict';

    angular
        .module('surveyCampaignControllers')
        .controller('CampaignSettingsController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'surveyCampaignService', 'campaign'];

    function Controller($scope, $state, topBarService, surveyCampaignService, campaign) {
        $scope.campaign = campaign;

        $scope.saveChanges = function () {
            surveyCampaignService
                .updateCampaign(campaign.SlugObject, $scope.campaign)
                .then(function () {
                    $state.go('survey.campaign.slug', {}, { reload: true });
                })
        };

        topBarService.setTitleAndIcon(campaign.TitleEN, 'fa fa-bullhorn', 'Settings', 'fa fa-sliders');
    }
})();